import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=f2a8991e&"
import script from "./ChatMessage.vue?vue&type=script&lang=js&"
export * from "./ChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=f2a8991e&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2a8991e')) {
      api.createRecord('f2a8991e', component.options)
    } else {
      api.reload('f2a8991e', component.options)
    }
    module.hot.accept("./ChatMessage.vue?vue&type=template&id=f2a8991e&", function () {
      api.rerender('f2a8991e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/vsl/ChatMessage.vue"
export default component.exports